module.exports = __webpack_public_path__ + "static/media/logo6.afb9baaf.jpg";